/* ST.BANDZ — Scroll Shine (scroll-scrubbed, mobile + desktop)
   1) Headings: a highlight sweeps letter by letter across each heading.
   2) Header BB logo: a white sheen sweeps across the logo as the page scrolls.
   (Hero + footer script logos are handled in snippets/society-script-logo.liquid.) */
(function () {
  if (window.__bzScrollShine) return;
  window.__bzScrollShine = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR =
    '#MainContent :is(h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6), footer :is(h1,h2,h3,h4,h5,h6)';
  var EXCLUDE =
    'product-card, .product-card, .resource-card, dialog, cart-drawer-component, .cart-drawer, header-component, .predictive-search, [data-no-shine]';

  var SWEEP_START = 0.2;
  var SWEEP_END = 0.8;
  var WIDTH = 0.3;

  var items = new Map();
  var active = new Set();
  var logos = [];
  var ticking = false;
  var io = null;

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = items.get(entry.target);
        if (!item) return;
        if (entry.isIntersecting) active.add(item);
        else active.delete(item);
      });
      requestTick();
    });
  }

  function split(el) {
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return null;

    var chars = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      var str = node.nodeValue;
      if (!str || !str.trim()) return;
      var frag = document.createDocumentFragment();

      str.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var word = document.createElement('span');
        word.className = 'bz-shine-word';
        word.setAttribute('aria-hidden', 'true');
        Array.from(part).forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'bz-shine-char';
          c.textContent = ch;
          word.appendChild(c);
          chars.push(c);
        });
        frag.appendChild(word);
      });

      node.parentNode.replaceChild(frag, node);
    });

    if (!chars.length) return null;
    if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', text);
    return chars;
  }

  function collectHeadings() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.closest(EXCLUDE)) return;
      var existing = items.get(el);
      if (existing && el.querySelector('.bz-shine-char')) return;

      var chars = split(el);
      if (!chars) return;

      var item = { el: el, chars: chars, last: new Array(chars.length).fill(-1) };
      items.set(el, item);
      if (io) io.observe(el);
      else active.add(item);
    });
  }

  function setupLogos() {
    logos = logos.filter(function (l) {
      return l.wrap.isConnected;
    });

    document.querySelectorAll('#header-component .header-logo__image').forEach(function (img) {
      var wrap = img.parentElement;
      if (!wrap || wrap.classList.contains('bz-logo-shine')) return;

      wrap.classList.add('bz-logo-shine');
      var sheen = document.createElement('span');
      sheen.className = 'bz-logo-sheen';
      sheen.setAttribute('aria-hidden', 'true');
      wrap.appendChild(sheen);

      function setMask() {
        var src = img.currentSrc || img.src;
        if (src) sheen.style.setProperty('--bz-logo-mask', 'url("' + src + '")');
      }
      setMask();
      img.addEventListener('load', setMask);

      logos.push({ wrap: wrap });
    });
  }

  function collect() {
    collectHeadings();
    setupLogos();
    requestTick();
  }

  function update(item) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = item.el.getBoundingClientRect();
    var p = (vh - r.top) / (vh + r.height);
    var t = (p - SWEEP_START) / (SWEEP_END - SWEEP_START);
    var c = t * (1 + 2 * WIDTH) - WIDTH;
    var n = item.chars.length;

    for (var i = 0; i < n; i++) {
      var f = n > 1 ? i / (n - 1) : 0.5;
      var d = Math.abs(f - c) / WIDTH;
      var s = d >= 1 ? 0 : 1 - d;
      s = s * s * (3 - 2 * s);
      s = Math.round(s * 100) / 100;
      if (s !== item.last[i]) {
        item.last[i] = s;
        item.chars[i].style.setProperty('--s', s);
      }
    }
  }

  function updateLogos() {
    if (!logos.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var period = Math.max(700, vh * 1.1); // one sweep per this much scrolling, repeats down the page
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var phase = (((y % period) + period) % period) / period;
    var pos = -140 + phase * 380;
    var u = Math.min(1, Math.max(0, (phase - 0.263) / 0.474));
    var glow = Math.sin(Math.PI * u);
    var posValue = pos.toFixed(1) + '%';
    var glowValue = glow.toFixed(2);

    logos.forEach(function (l) {
      l.wrap.style.setProperty('--bz-logo-shine', posValue);
      l.wrap.style.setProperty('--bz-logo-glow', glowValue);
    });
  }

  function frame() {
    ticking = false;
    active.forEach(update);
    updateLogos();
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  var moTimer = null;
  function observeMutations() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(collect, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    collect();
    observeMutations();
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
    window.addEventListener('orientationchange', requestTick, { passive: true });
    window.addEventListener('load', requestTick);
    document.addEventListener('shopify:section:load', collect);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
